import React from 'react';

import Expandable from 'components/global/application/Expandable';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';

import InventoryFilterInputs from 'containers/pages/inventory/InventoryFilterInputs';

import { BREAK_POINT } from 'constants/responsive';

// Styles
import 'react-select/dist/react-select.css'; // import this here because we use their stylings on the select lookalike
import './InventoryFilter.sass';

interface Props { // Getting these from parent component to reduce redux container boiler plate
    expandFilter?: boolean;
    isMobile: boolean;
    viewFilters: boolean;
    toggleFilterView(value: boolean): void;
    updateQueryString(key: string, value?: string): void;
    updateCategory(value: string): void;
}

interface IState {
    moreInfoExpanded: boolean;
    filterExpanded: boolean; // desktop only
}

class InventoryFilter extends React.Component<Props, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            filterExpanded: this.props.expandFilter ? true : false, // undefined values are sometimes treated as though the property is never set
            moreInfoExpanded: false
        };

        this.showOptionsToggle = this.showOptionsToggle.bind(this);
    }

    public render() {
        return this.props.isMobile ? this.renderMobile() : this.renderDesktop();
    }

    public showOptionsToggle = () => {
        this.props.toggleFilterView(!this.props.viewFilters);
        // this.setState({ filterExpanded: !this.state.filterExpanded });
    }

    public moreInfoToggle = () => {
        this.setState({ moreInfoExpanded: !this.state.moreInfoExpanded });
    }

    public renderMobile() {
        return (
            <div className={`InventoryFilter-container-mobile Select Select--single Filter-options-dropdown${this.props.viewFilters ? '-dark' : ''}`}>
                {/* bare in mind the div below is using class names from the react-select package to make it look like a select but not act like one */}
                <div className="Select-look-alike" onClick={this.showOptionsToggle}>
                    Filter Your Results
                    <span className="">
                        <span className="Select-arrow Select-arrow-lookalike" />
                    </span>
                </div>
                <Expandable className="InventoryFilterOptions-container-mobile" expanded={this.props.viewFilters} direction="vertical" maxHeight="860px">
                    <div className="PadBottom-container">
                        <InventoryFilterInputs
                            updateQueryString={this.props.updateQueryString}
                            updateCategory={this.props.updateCategory}
                        />
                        <div className="More-information" onClick={this.moreInfoToggle}>
                            More Information <FontAwesome name={this.state.moreInfoExpanded ? 'chevron-down' : 'chevron-right'} />
                        </div>
                        <Expandable className="More-info-sub" expanded={this.state.moreInfoExpanded} direction="vertical" maxHeight="210px">
                            <div className="PadTop-container">
                                {getMoreInfo().map(text => <div key={text}>{text}</div>)}
                            </div>
                        </Expandable>
                    </div>
                </Expandable>
            </div>
        );
    }

    public renderDesktop() {
        return (
            <div className="InventoryFilter-container">
                <span className="Inventory-filter-header"  onClick={this.showOptionsToggle} >
                    Filter Your Results
                    <FontAwesome className="Filter-arrow" name={`chevron-${this.props.viewFilters ? 'down' : 'right'}`} />
                </span>
                <Expandable direction="vertical" maxHeight="50em" expanded={this.props.viewFilters} >
                    <InventoryFilterInputs
                        updateQueryString={this.props.updateQueryString}
                        updateCategory={this.props.updateCategory}
                    />
                </Expandable>
                <hr />
                <div className="More-information" onClick={this.moreInfoToggle}>
                    More Information <FontAwesome name={this.state.moreInfoExpanded ? 'chevron-down' : 'chevron-right'} className="Filter-arrow" />
                </div>
                <Expandable className="More-info-sub" direction="vertical" maxHeight="18em" expanded={this.state.moreInfoExpanded} >
                    {getMoreInfo().map(text => <div key={text}>{text}</div>)}
                </Expandable>
            </div>
        );
    }
}

const getMoreInfo = (): string[] => ([
    'Abbreviations used in this inventory:',
    'M = Mint',
    'NM = Near Mint',
    'EXF = Exceptionally Fine',
    'EXC = Excellent',
    'VG = Very Good',
    'G = Good',
    'OHC = Original Hard Case',
    'HC = Hard Case',
    'OSC = Original Soft Case',
    'SC = Soft Case'
]);

export default InventoryFilter;



// WEBPACK FOOTER //
// ./src/components/pages/inventory/InventoryFilter.tsx